/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-15 10:43:47
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-02-02 15:43:52
 */
const getters = {
  device: state => state.app.device,
  language: state => state.app.language,
  i18nLocale: state => state.app.i18nLocale,
  scrollTop: state => state.app.scrollTop,
  clientWidth: state => state.app.clientWidth,
  clientHeight: state => state.app.clientHeight,
  permission_routes: state => state.permission.routes
}
export default getters
